import { render, staticRenderFns } from "./simple-national.vue?vue&type=template&id=84dcdaa4"
import script from "./simple-national.vue?vue&type=script&lang=js"
export * from "./simple-national.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports